// removed by extract-text-webpack-plugin
module.exports = {"poster-view-date-card-mobile":"poster-view-date-card-mobile"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/PosterView/DateCardMobile.scss
// module id = mk72
// module chunks = 0